export const REP_ASSIGNED = 'LEAD_REP_ASSIGNED'
export const PRIMARY_REP_ASSIGNED = 'LEAD_PRIMARY_REP_ASSIGNED'
// `properties.assignment_source` on a rep assignment made by a public profile form
export const PUBLIC_PROFILE_ASSIGNMENT_SOURCE = 'PUBLIC_PROFILE'
export const IN_CONTRACTS = 'LEAD_IN_CONTRACTS'
export const IS_ACQUIRED = 'LEAD_IS_ACQUIRED'
export const BE_BACK = 'LEAD_BE_BACK'
export const LEAD_MARKED_AS_INACTIVE = 'LEAD_MARKED_AS_INACTIVE'
export const ONSITE = 'LEAD_MARKED_ON_SITE'
export const MISSED = 'LEAD_MARKED_AS_MISSED'
export const CANCELED = 'LEAD_MARKED_AS_CANCELED'
export const ACQUISITION_LIST_COMPLETED = 'LEAD_ACQUISITION_COMPLETED'
export const APPRAISAL_LIST_COMPLETED = 'LEAD_APPRAISAL_COMPLETED'
export const LEAD_POSTPONE_STEP = 'LEAD_POSTPONE_STEP'
export const LEAD_REMINDER_LATER_NOTE = 'LEAD_REMINDER_LATER_NOTE'
export const LEAD_MARKED_DESKLOG = 'LEAD_MARKED_DESKLOG'
export const LEAD_MARKED_F_AND_I = 'LEAD_MARKED_F_AND_I'
export const LEAD_DESKLOG_COMPLETED = 'LEAD_DESKLOG_COMPLETED'
export const LEAD_F_AND_I_COMPLETED = 'LEAD_F_AND_I_COMPLETED'
export const LEAD_MERGED_TO = 'LEAD_MERGED_TO'
export const LEAD_MERGED = 'LEAD_MERGED'
export const LEAD_REQUEST_INACTIVE = 'LEAD_REQUEST_INACTIVE'
export const LEAD_REQUEST_INACTIVE_APPROVED = 'LEAD_REQUEST_INACTIVE_APPROVED'
export const LEAD_REQUEST_INACTIVE_REJECT = 'LEAD_REQUEST_INACTIVE_REJECT'
export const LEAD_REQUEST_INACTIVE_UNDO = 'LEAD_REQUEST_INACTIVE_UNDO'
export const LEAD_REQUEST_INACTIVE_REASSIGN = 'LEAD_REQUEST_INACTIVE_REASSIGN'
export const LEAD_REACTIVATE = 'LEAD_REACTIVATE'
export const LEAD_REQUEST_INACTIVE_CANCELED = 'LEAD_REQUEST_INACTIVE_CANCELED'
export const LEAD_ADD_TO_CAMPAIGN = 'LEAD_ADD_TO_CAMPAIGN'
export const LEAD_REMOVED_FROM_CAMPAIGN = 'LEAD_REMOVED_FROM_CAMPAIGN'
export const LEAD_CAMPAIGN_ENDED_EARLY = 'LEAD_CAMPAIGN_ENDED_EARLY'
export const LEAD_CAMPAIGN_EXIST_EARLY = 'LEAD_CAMPAIGN_EXIST_EARLY'
export const LEAD_CAMPAIGN_COMPLETED = 'LEAD_CAMPAIGN_COMPLETED'
export const LEAD_CAMPAIGN_ENGAGED = 'LEAD_CAMPAIGN_ENGAGED'
export const LEAD_CAMPAIGN_STARTED = 'LEAD_CAMPAIGN_STARTED'
export const LEAD_MARKED_AS_VEHICLE_MATCH = 'LEAD_MARKED_AS_VEHICLE_MATCH'
export const LEAD_VEHICLE_MATCH_FOUND = 'LEAD_VEHICLE_MATCH_FOUND'
export const LEAD_REQUEST_REACTIVATE = 'LEAD_REQUEST_REACTIVATE'
export const LEAD_WORKFLOW_INACTIVATE = 'LEAD_WORKFLOW_INACTIVATE'
export const LEAD_WORKFLOW_INACTIVATE_APPROVE = 'LEAD_WORKFLOW_INACTIVATE_APPROVE'
export const LEAD_WORKFLOW_INACTIVATE_PENDING = 'LEAD_WORKFLOW_INACTIVATE_PENDING'
export const LEAD_WORKFLOW_INACTIVATE_RESTARTED = 'LEAD_WORKFLOW_INACTIVATE_RESTARTED'
export const LEAD_POSTPONE_STEP_REQUEST = 'LEAD_POSTPONE_STEP_REQUEST'
export const LEAD_POSTPONE_STEP_APPROVE = 'LEAD_POSTPONE_STEP_APPROVE'
export const LEAD_POSTPONE_STEP_REJECT = 'LEAD_POSTPONE_STEP_REJECT'
export const LEAD_GLOBAL_DNC_ADDED = 'LEAD_GLOBAL_DNC_ADDED'
export const LEAD_CALL_DNC_ADDED = 'LEAD_CALL_DNC_ADDED'
export const LEAD_CALL_DNC_REMOVED = 'LEAD_CALL_DNC_REMOVED'
export const LEAD_SMS_DNC_ADDED = 'LEAD_SMS_DNC_ADDED'
export const LEAD_SMS_DNC_REMOVED = 'LEAD_SMS_DNC_REMOVED'
export const LEAD_CHAT_DNC_ADDED = 'LEAD_CHAT_DNC_ADDED'
export const LEAD_CHAT_DNC_REMOVED = 'LEAD_CHAT_DNC_REMOVED'
export const LEAD_EMAIL_DNC_ADDED = 'LEAD_EMAIL_DNC_ADDED'
export const LEAD_EMAIL_DNC_REMOVED = 'LEAD_EMAIL_DNC_REMOVED'
export const LEAD_SURVEY_SUBMITTED = 'LEAD_SURVEY_SUBMITTED'
export const LEAD_SURVEY_SUBMISSION_CONFIRMED = 'LEAD_SURVEY_SUBMISSION_CONFIRMED'
export const LEAD_WORKFLOW_REACTIVATE_RESTARTED = 'LEAD_WORKFLOW_REACTIVATE_RESTARTED'
export const LEAD_APPOINTMENT_REQUEST = 'LEAD_APPOINTMENT_REQUEST'
export const LEAD_APPOINTMENT_SCHEDULED_APPROVED = 'LEAD_APPOINTMENT_SCHEDULED_APPROVED'
